import { FC, useEffect } from "react";
import PopularNow from "./components/PopularNow";
// import FooterHome from "./components/FooterHome";
import homeStore from "./store/homeStore";
import { observer } from "mobx-react-lite";
import { FormInput } from "../../components/ui/Form/FormInput";
import Button from "../../components/ui/Button";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router";
import { isMobile } from "react-device-detect";
import StoreMap from "./components/StoreMap";
import { Helmet } from "react-helmet-async";
import appStore from "../../stores/appStore";
import Banner from "./components/Banner";
import CategoriesGrid from "./components/CategoriesGrid";
import NewProducts from "./components/NewProducts";

interface SearchFormData {
  search: string;
}

const Home: FC = () => {
  useEffect(() => {
      homeStore.fetchPopularNow();
      homeStore.fetchStoreLocation();
      homeStore.fetchBanner();
      homeStore.fetchNewProducts();

  }, []);

  const { register, handleSubmit } = useForm<SearchFormData>();

  const onSubmit = (data: SearchFormData) => {
    if (data.search.trim()) {
      window.location.href = `/search?search=${encodeURIComponent(
        data.search.trim()
      )}`;
    }
  };

  const [searchParams] = useSearchParams();

  // const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div className="flex flex-col gap-[25px] md:gap-[30px] h-max p-4">
      <Helmet>
        <>
          <title>КЦ Авто | Главная</title>
          <meta
            name="description"
            content={`КЦ авто домашняя страница главная страница купить автозапчасти Корея центр`}
          />
          <meta
            name="keywords"
            content="КЦ Авто, интернет магазин автозапчастей, поиск запчастей, купить автозапчасти"
          />
        </>
      </Helmet>
      {isMobile ? (
        <div className="flex flex-1 items-center gap-4">
          {/* Форма поиска */}
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex flex-1 rounded-[12px]"
            style={{
              boxShadow: "0 2px 20px rgba(0, 0, 0, 0.1)",
              WebkitBoxShadow: "0 2px 20px rgba(0, 0, 0, 0.1)",
            }}
          >
            <FormInput
              {...register("search")}
              placeholder="Поиск"
              className="rounded-r-none w-full h-[45px] !px-[15px] flex-1 border-none appearance-none !shadow-none"
              classNameForm="w-full"
              defaultValue={searchParams.get("search") || ""}
            />
            <Button
              style="primary"
              type="submit"
              className="!rounded-l-none !rounded-[12px] !border-[1px] h-[44px] !border-white flex-shrink-0 appearance-none !shadow-none"
            >
              Найти
            </Button>
          </form>
        </div>
      ) : (
        false
      )}
      {/* <div className="w-full rounded-2xl bg-[#383181] p-4 text-white font-semibold text-2xl text-center">
        Ежедневно мы улучшаем сайт и добавляем новые функции для вас!
      </div> */}

      {appStore.selectedCity &&
        homeStore.banner &&
        homeStore.banner.cities.includes(appStore.selectedCity) && (
          <Banner banner={homeStore.banner}></Banner>
        )}
        <div className="flex flex-col gap-[25px] md:gap-[30px] mb-[50px]">
      <PopularNow />
      <CategoriesGrid></CategoriesGrid>
      <NewProducts></NewProducts>
      { <StoreMap></StoreMap>}
        </div>

    </div>
  );
};

export default observer(Home);
